import { rgba } from 'polished'
import styled from 'styled-components'

const NumericKeypad = ({ value, onChange, onSubmit, maxLength, square }) => {
  const handleDigit = (digit) => {
    if (maxLength && value.length >= maxLength) return
    onChange(value + digit)
  }

  const handleBackspace = () => {
    onChange(value.slice(0, -1))
  }

  const handleClear = () => {
    onChange('')
  }

  return (
    <KeypadGrid $square={square}>
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map(d => (
        <KeypadKey key={d} $square={square} onClick={() => handleDigit(d)}>{d}</KeypadKey>
      ))}
      <KeypadKey $muted $square={square} onClick={handleClear}>C</KeypadKey>
      <KeypadKey $square={square} onClick={() => handleDigit('0')}>0</KeypadKey>
      <KeypadKey $muted $square={square} onClick={handleBackspace}>
        <BackspaceIcon viewBox="0 0 24 24">
          <path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z" />
        </BackspaceIcon>
      </KeypadKey>
      {onSubmit && (
        <SubmitKey $square={square} onClick={onSubmit} disabled={!value.trim()}>OK</SubmitKey>
      )}
    </KeypadGrid>
  )
}

export default NumericKeypad

const KeypadGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  width: 100%;
`

const KeypadKey = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ $square }) => $square ? '60px' : '56px'};
  padding: 0;
  border: 1px solid var(--color-line);
  border-radius: 12px;
  background: ${({ $muted }) => $muted ? '#F6F7F9' : '#ffffff'};
  font-size: ${({ $square }) => $square ? '1.4rem' : '1.5rem'};
  font-weight: 600;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
  color: ${({ $muted, theme }) => $muted ? theme.colors.muted : theme.colors.global};
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.1s ease-out, background-color 0.1s;

  &:active {
    background: ${({ theme }) => rgba(theme.colors.global, 0.08)};
    transform: scale(0.96);
  }
`

const SubmitKey = styled.button`
  grid-column: 1 / -1;
  min-height: ${({ $square }) => $square ? '64px' : '56px'};
  padding: 0 16px;
  border: none;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.primary};
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-family: inherit;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.1s ease-out, opacity 0.1s;

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }

  &:not(:disabled):active {
    opacity: 0.88;
    transform: scale(0.98);
  }
`

const BackspaceIcon = styled.svg`
  width: 24px;
  height: 24px;
  fill: currentColor;
`
